import { render } from "./PatientTherapyConcept.vue?vue&type=template&id=425a8da4"
import script from "./PatientTherapyConcept.vue?vue&type=script&lang=js"
export * from "./PatientTherapyConcept.vue?vue&type=script&lang=js"

import "./PatientTherapyConcept.vue?vue&type=style&index=0&id=425a8da4&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/DACY_Demo_Server/kbdemo_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__